import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {ColumnMode} from '@almaobservatory/ngx-datatable';
import {PlatformLocation} from "@angular/common";

@Component({
  selector: 'asax-result-table-cell-similarity-for-project',
  templateUrl: './cell-similarity-for-project.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CellSimilarityForProjectComponent {
  @Input() projects: any[];

  ColumnMode = ColumnMode;

  constructor(private platformLocation: PlatformLocation) {
  }

  buildUrlFilteringByProjectCode(projectCode: string): string {
    const location = (this.platformLocation as any).location;
    const projectCodeEncoded = encodeURIComponent(projectCode);
    return `${location.origin}${location.pathname}?result_view=projects&projectCode=${projectCodeEncoded}`;
  }
}
